<template>
  <div class="container">
    <img class="banner img-fluid"
         src="https://www.insularhealthcare.com.ph/wp-content/uploads/2022/03/gcash-banner.png"
         alt="Online Payments">

    <p class="instructions">For any concerns, instructions and if you want to share the confirmation page of your payment, please
      email <a href="mailto:cashier@insularhealthcare.com.ph"><em>cashier@insularhealthcare.com.ph</em></a>. Please note that your payment will be verified and once validated, it will
      be officially acknowledged by the issuance of an <em>Official Receipt</em>.
    </p>

    <payment-form v-if="selectedPayment !== null" :payment="selectedPayment"></payment-form>
  </div>
</template>

<script>
import PaymentForm from "./components/PaymentForm";

export default {
  name: 'App',
  components: {
    PaymentForm
  },
  data() {
    return {
      selectedPayment: {
        type: 'gcash',
        title: 'GCash',
        logo: 'https://www.insularhealthcare.com.ph/wp-content/uploads/2022/03/gcash-logo.png',
        payments_for: ['InHealth Persona', 'Privilege Care', 'Availment outside HMO coverage']
      }
    }
  }
}
</script>

<style scoped lang="scss">
.instructions {
  margin-top: 20px;
  margin-bottom: 40px;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #00979d;
  background-color: #00979d;
}

.custom-control-label {
  font-size: 1.1rem;
}

.payment-type {
  padding: 10px 15px;

}

.label-img {
  max-height: 40px;
  float: right;
  padding-left: 15px;
  margin-top: -15px;
}

.banner {
  margin-bottom: 20px;
}

p {
  text-align: justify
}

.steps {
  padding-left: 0;
}

.steps li {
  list-style: none;
}

.step-label, .payment-type-title {
  color: #00979d;
  font-weight: bold;
}

.payment-type-title {
  text-align: left;
  margin-bottom: 20px;
}

@media only screen and (max-width: 992px) {
  #payment > div > div > div:nth-child(1) > div:nth-child(2) > label > img {
    max-height: 40px !important;
    float: left !important;
    padding-left: 0 !important;
    margin-top: 0 !important;
    margin-left: -19px !important;
  }

  .label-img {
    float: none !important;
    padding-left: 0 !important;
    margin-top: 0 !important;
    display: block !important;
  }

  .payment-type-title {
    margin-bottom: 0 !important;
    margin-top: 30px !important;
  }
}

</style>
